import React from 'react';

import ReturnOrderShowView from '@components/shared/return_orders/ReturnOrderShowView';
import { useLoaderData } from 'react-router-dom';

import { returnOrderService } from '@services/admin/returnOrderService';

export default function ReturnOrderShow() {
  const returnOrder = useLoaderData();

  return (
    <ReturnOrderShowView
      returnOrder={returnOrder}
      role="admin"
      returnOrderService={returnOrderService}
    />
  );
}
